import Login from "views/common/Login";
import ResetPassword from "views/common/ResetPassword";
import ChangePassword from "views/common/ChangePassword";
import RoleSelection from "views/common/RoleSelection";
import Home from "views/professional/Home";
import ProfessionalManualSignup from "views/professional/ProfessionalManualSignup";
import ProfessionalSocialMediaSignup from "views/professional/ProfessionalSocialMediaSignup";
import LearningPage from "views/professional/LearningPage";
import CommunityPage from "views/professional/CommunityPage";
import Profile from "layouts/Profile";
import RequireAuth from "layouts/RequireAuth";
import { Toaster } from "react-hot-toast";
import Pricing from "views/common/Pricing";
import { Route, Routes } from "react-router-dom";
import SuccessPayment from "views/common/SuccessPayment";
import FailurePayment from "views/common/FailurePayment";
import ProfessionalHome from "views/professional/ProfessionalHome";
import JobWorkSpaceRightContent from "layouts/Home/JobWorkSpaceRightContent";
import EmployerManualSignup from "views/employer/EmployerManualSignup";
import EmployerHome from "views/employer/EmployerHome";
import EmployerAuth from "views/employer/EmployerAuth";
import EmployerCandidates from "views/employer/EmployerCandidates";
import EmployerPool from "views/employer/EmployerPool";
import EmployerProfile from "views/employer/EmployerProfile";
import CandidateRightMinimumDeviceCard from "views/employer/employerComponents/CandidateRightMinimumDeviceCard";
import MultiStepForm from "views/employer/MultiStepForm";
import EmployerRequireAuth from "./hooks/EmployerRequireAuth";
import PartnerProfile from "views/partner/PartnerProfile";
import PartnerRequireAuth from "./hooks/PartnerRequireAuth";
import PartnerAuth from "views/partner/PartnerAuth";
import PartnerManualSignup from "views/partner/PartnerManualSignup";
import PartnerHome from "views/partner/PartnerHome";
import PartnerHomeAndReview from "views/partner/PartnerHomeAndReview";
import SuperAdminProfessional from "views/SuperAdmin/SuperAdminProfessional";
import SuperAdminEmployer from "views/SuperAdmin/SuperAdminEmployer";
import SuperAdminAnalysis from "views/SuperAdmin/SuperAdminAnalysis";
import SuperAdminStateManagement from "views/SuperAdmin/Resuable_Comp/SuperAdminStateManagement";
import ProfessionalMinDevice from "views/SuperAdmin/Resuable_Comp/ProfessionalMinDevice";
import EmployerMinDevice from "views/SuperAdmin/Resuable_Comp/EmployerMinDevice";
import SuperAdminAuth from "views/SuperAdmin/SuperAdminAuth";
import EmployerPricing from "views/employer/EmployerPricing";
import PartnerPricing from "views/partner/PartnerPricing";
import PageNotFound from "layouts/PageNotFound";
import Dashboard from "layouts/Dashboard";
import SuperAdminJobs from "views/SuperAdmin/SuperAdminJobs";
import JobsMinDevice from "views/SuperAdmin/Resuable_Comp/JobsMinDevice";
import ProfessionalSubscriptionExpired from "views/professional/ProfessionalSubscriptionExpired";
import EmployerSubscriptionExpired from "views/employer/EmployerSubscriptionExpired";
import PartnerSubscriptionExpired from "views/partner/PartnerSubscriptionExpired";
import SuperAdminPartner from "views/SuperAdmin/SuperAdminPartner";
import PartnerMinDevice from "views/SuperAdmin/Resuable_Comp/PartnerMinDevice";
import InvitedApplicants from "views/employer/invitedApplicants";
import BestFitCandidates from "views/employer/BestFitCandidates";
import CreateNewEmployerPassword from "views/common/CreateNewEmployerPassword";
import JobApplicantView from "views/SuperAdmin/ApplicantView/JobApplicantView";
import InitalizeProjectSetup from "views/common/InitalizeProjectSetup";
import SaInvitedApplicants from "views/SuperAdmin/ApplicantView/Components/SaInvitedApplicants";
import EventRegister from "views/professional/EventRegister";
import SaBestFit from "views/SuperAdmin/ApplicantView/Components/SaBestFit";
import Help from "views/professional/Help";


function App() {
  return (
    <>
      <Toaster />
      <Routes>
        <Route element={<InitalizeProjectSetup />}>
          <Route path="/" element={<Login />} />
          <Route path="/forgot_password" element={<ChangePassword />} />
          <Route path="/reset_password" element={<ResetPassword />} />
          <Route path="/create_sub_user_password" element={<CreateNewEmployerPassword />} />
          <Route path="/role_selection" element={<RoleSelection />} />
          <Route path="/role_selection/professional_signup">
            <Route index path="manual" element={<ProfessionalManualSignup />} />
            <Route path="social_media" element={<ProfessionalSocialMediaSignup />} />
          </Route>

          <Route path="/role_selection/employer_signup">
            <Route index path="manual" element={<EmployerManualSignup />} />
          </Route>

          <Route path="/role_selection/partner_signup">
            <Route index path="manual" element={<PartnerManualSignup />} />
          </Route>

          <Route path="employer_signup/manual" element={<EmployerManualSignup />} />

          <Route element={<RequireAuth />}>
            <Route path="professional" element={<ProfessionalHome />}>
              <Route path="home" element={<Home />} />
              <Route path="all_jobs" element={<Dashboard />} />
              <Route path="recommended_jobs" element={<Dashboard />} />
              <Route path="applied_jobs" element={<Dashboard />} />
              <Route path="saved_jobs" element={<Dashboard />} />
              <Route path="job_Details" element={<JobWorkSpaceRightContent />} />
              <Route path="profile" element={<Profile />} />
              <Route path="pricing-plan" element={<Pricing />} />
              <Route path="learning" element={<LearningPage />} />
              <Route path="help" element={<Help />} />
              <Route path="community" >
                <Route index element={<CommunityPage />} />
                <Route path="event_register" element={<EventRegister />} />
              </Route>
            </Route>
            <Route path="professional/profession_upgrade_plan" element={<ProfessionalSubscriptionExpired />} />
          </Route>

          <Route element={<EmployerRequireAuth />}>
            <Route path="employer_dashboard" element={<EmployerAuth />}>
              <Route path="home" element={<EmployerHome />} />
              <Route path="multistepForm" element={<MultiStepForm />} />
              <Route path="candidates" element={<EmployerCandidates />} />
              <Route path="candidates/full_details" element={<CandidateRightMinimumDeviceCard />} />
              <Route path="invited_applicants" element={<InvitedApplicants />} />
              <Route path="best_fit_candidates" element={<BestFitCandidates />} />
              <Route path="pool" element={<EmployerPool />} />
              <Route path="profile" element={<EmployerProfile />} />
              <Route path="pricing-plan" element={<EmployerPricing />} />
              <Route path="help" element={<Help />} />
            </Route>
            <Route path="employer_dashboard/upgrade_plan" element={<EmployerSubscriptionExpired />} />
          </Route>

          <Route element={<PartnerRequireAuth />}>
            <Route path="partner_dashboard" element={<PartnerAuth />}>
              <Route path="home" element={<PartnerHome />} />
              <Route path="cardForm" element={<PartnerHomeAndReview />} />
              <Route path="profile" element={<PartnerProfile />} />
              <Route path="pool" element={<EmployerPool />} />
              <Route path="pricing-plan" element={<PartnerPricing />} />
            </Route>
            <Route path="partner_dashboard/upgrade_plan" element={<PartnerSubscriptionExpired />} />
          </Route>

          <Route element={<SuperAdminAuth />}>
            <Route path="super_admin" element={<SuperAdminStateManagement />}>
              <Route path="professional">
                <Route index exact element={<SuperAdminProfessional />} />
                <Route path="candidates_details" element={<ProfessionalMinDevice />} />
              </Route>

              <Route path="employer">
                <Route index exact element={<SuperAdminEmployer />} />
                <Route path="employer_details" element={<EmployerMinDevice />} />
              </Route>

              <Route path="jobs">
                <Route index exact element={<SuperAdminJobs />} />
                <Route path="job_id" element={<JobApplicantView />} />
                <Route path="invited_applicants" element={<SaInvitedApplicants />} />
                <Route path="bestfit_applicants" element={<SaBestFit />} />
                <Route path="job_details" element={<JobsMinDevice />} />
              </Route>

              <Route path="partner">
                <Route index exact element={<SuperAdminPartner />} />
                <Route path="partner_details" element={<PartnerMinDevice />} />
              </Route>

              <Route path="analysis" element={<SuperAdminAnalysis />} />
            </Route>
          </Route>

          <Route path="/checkout_success" element={<SuccessPayment />} />
          <Route path="/checkout_failure" element={<FailurePayment />} />
          <Route path="*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;